/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchPatientRequest
 */
export interface SearchPatientRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchPatientRequest
     */
    institutes?: Array<string>;
}

/**
 * Check if a given object implements the SearchPatientRequest interface.
 */
export function instanceOfSearchPatientRequest(value: object): value is SearchPatientRequest {
    return true;
}

export function SearchPatientRequestFromJSON(json: any): SearchPatientRequest {
    return SearchPatientRequestFromJSONTyped(json, false);
}

export function SearchPatientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPatientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'institutes': json['institutes'] == null ? undefined : json['institutes'],
    };
}

export function SearchPatientRequestToJSON(json: any): SearchPatientRequest {
    return SearchPatientRequestToJSONTyped(json, false);
}

export function SearchPatientRequestToJSONTyped(value?: SearchPatientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'institutes': value['institutes'],
    };
}

